module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('tab', {
    attrs: {
      "active-color": "#fc2d65"
    }
  }, _vm._l((_vm.statusList), function(item, index) {
    return _c('tab-item', {
      key: index,
      attrs: {
        "selected": _vm.listParams.status === item.status
      },
      nativeOn: {
        "click": function($event) {
          _vm.changeTab(item)
        }
      }
    }, [_vm._v(_vm._s(item.text))])
  })), _vm._v(" "), _c('scroller', {
    ref: "scrollerBottom",
    attrs: {
      "lock-x": "",
      "height": _vm.h,
      "scroll-bottom-offset": 50
    },
    on: {
      "on-scroll-bottom": _vm.scrollBtm
    }
  }, [_c('div', [(_vm.list.length > 0) ? _c('ul', {
    staticClass: "content"
  }, _vm._l((_vm.list), function(order, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          _vm.toDetail(order)
        }
      }
    }, [_vm._l((order.products), function(item, index2) {
      return _c('div', {
        key: item.num,
        staticClass: "content  vux-1px-b"
      }, [_c('div', {
        staticClass: "flex"
      }, [_c('div', {
        staticClass: "pic"
      }, [_c('img', {
        attrs: {
          "src": _vm.UPLOAD_DOMAIN + item.thumbnail + '?x-oss-process=image/resize,w_120',
          "alt": ""
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "text text-l flex-1"
      }, [_c('p', [_vm._v(_vm._s(item.title)), (item.specLabel) ? _c('span', [_vm._v("(" + _vm._s(item.specLabel) + ")")]) : _vm._e(), (item.areaLimit) ? _c('span', [_vm._v("(限售湖北)")]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.subTitle) + " "), _c('span', {
        staticClass: "fr"
      }, [_vm._v("X" + _vm._s(item.quantity))])]), _vm._v(" "), _c('p', {
        staticClass: "text-r"
      }, [_vm._v("￥" + _vm._s(_vm._f("fen2yuan")(item.price)))])])])])
    }), _vm._v(" "), _c('div', {
      staticClass: "num-text text-r vux-1px-b"
    }, [_vm._v("\n                        共" + _vm._s(_vm.totalCount(order)) + "件 "), (order.discount) ? _c('span', [_vm._v("优惠￥" + _vm._s(_vm._f("fen2yuan")(order.discount)))]) : _vm._e(), _vm._v(" "), (order.freight) ? _c('span', [_vm._v("运费￥" + _vm._s(_vm._f("fen2yuan")(order.freight)))]) : _vm._e(), _vm._v(" 小计￥" + _vm._s(_vm._f("fen2yuan")(order.payable)) + "\n                    ")]), _vm._v(" "), (order.shippingInfo && order.shippingInfo.company) ? _c('div', {
      staticClass: "num-text text-r vux-1px-b"
    }, [_vm._v("\n                        发货信息: " + _vm._s(order.shippingInfo.company) + " 单号:"), (order.shippingInfo.number) ? _c('span', [_vm._v(_vm._s(order.shippingInfo.number))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "foot"
    }, [(order.status == 'unpaid') ? _c('button', {
      staticClass: "pay-btn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.paySelect(order._id)
        }
      }
    }, [_vm._v("付款")]) : _vm._e(), _vm._v(" "), (order.status == 'unpaid') ? _c('button', {
      staticClass: "cancal-order",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.cancelOrder(order._id)
        }
      }
    }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), (order.status == 'paid') ? _c('button', {
      staticClass: "cancal-order red"
    }, [_vm._v("待发货")]) : _vm._e(), _vm._v(" "), (order.createdBy != 'prize' && (order.status == 'paid' || order.status == 'shipped' || order.status == 'received')) ? _c('button', {
      staticClass: "cancal-order",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.refundOrder(order._id)
        }
      }
    }, [_vm._v("申请退款")]) : _vm._e(), _vm._v(" "), (order.shippingInfo) ? _c('button', {
      staticClass: "cancal-order red",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.expressInfo(order._id)
        }
      }
    }, [_vm._v("查看物流")]) : _vm._e(), _vm._v(" "), (order.status == 'shipped' && !order.shippingInfo) ? _c('button', {
      staticClass: "cancal-order"
    }, [_vm._v("已发货")]) : _vm._e(), _vm._v(" "), (order.status == 'received') ? _c('button', {
      staticClass: "cancal-order"
    }, [_vm._v("已完成")]) : _vm._e(), _vm._v(" "), (order.status == 'refunding') ? _c('button', {
      staticClass: "cancal-order"
    }, [_vm._v("申请退款中")]) : _vm._e(), _vm._v(" "), (order.status == 'refunded') ? _c('button', {
      staticClass: "cancal-order"
    }, [_vm._v("退款完成")]) : _vm._e(), _vm._v(" "), (order.status == 'cancelled') ? _c('button', {
      staticClass: "cancal-order"
    }, [_vm._v("已取消")]) : _vm._e()])], 2)
  })) : _vm._e(), _vm._v(" "), (_vm.isLoadMore) ? _c('load-more', {
    attrs: {
      "show-loading": false,
      "tip": '加载完全部数据',
      "background-color": "#fbf9fe"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('popup', {
    attrs: {
      "height": "100%",
      "show-mask": false
    },
    model: {
      value: (_vm.show1),
      callback: function($$v) {
        _vm.show1 = $$v
      },
      expression: "show1"
    }
  }, [_c('view-box', [(_vm.show1) ? _c('div', {
    staticClass: "cause-list"
  }, [_c('group', {
    attrs: {
      "title": "fill mode with custom placeholder and label"
    }
  }, [_c('radio', {
    staticClass: "text-l",
    attrs: {
      "options": _vm.radio001
    },
    on: {
      "on-change": _vm.canceOrderOpt
    }
  }), _vm._v(" "), _c('x-textarea', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cancel_reason == 'other'),
      expression: "cancel_reason=='other'"
    }],
    attrs: {
      "placeholder": "请填写原因"
    },
    model: {
      value: (_vm.other_reason),
      callback: function($$v) {
        _vm.other_reason = $$v
      },
      expression: "other_reason"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "1rem"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "cancaleBtn",
    on: {
      "click": function($event) {
        _vm.cancaleBtn(_vm.cancel_reason, _vm.other_reason)
      }
    }
  }, [_vm._v("提交申请")])], 1)], 1) : _vm._e()])], 1), _vm._v(" "), (!_vm.list.length) ? _c('no-data') : _vm._e(), _vm._v(" "), _c('Confirm', {
    attrs: {
      "show-cancel": "",
      "cancel-text": "取消"
    },
    on: {
      "on-confirm": _vm.cancelBtn2
    },
    model: {
      value: (_vm.show2),
      callback: function($$v) {
        _vm.show2 = $$v
      },
      expression: "show2"
    }
  }, [_vm._v(_vm._s(_vm.titleName2 == '取消订单' ? '是否确定取消订单' : '是否确定申请退款'))]), _vm._v(" "), _c('actionsheet', {
    attrs: {
      "menus": _vm.payMethodList,
      "close-on-clicking-mask": false,
      "show-cancel": ""
    },
    on: {
      "on-click-menu": _vm.toPay,
      "on-click-mask": function($event) {
        _vm.showPayList = false
      }
    },
    model: {
      value: (_vm.showPayList),
      callback: function($$v) {
        _vm.showPayList = $$v
      },
      expression: "showPayList"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eccaab5e"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderList/all.vue
// module id = 622
// module chunks = 0